{
  "#GESAMTABFRAGE": {
    "TITLE": "Belege",
    "MENU": {
      "TITLE": "Belege",
      "FIND": "Suchen",
      "RESULTS": "Ergebnisse",
      "BUSINESS_CASE": "Geschäftsfall"
    },
    "PAGES": {
      "TYPE": {
        "HEADER": "Belegarten"
      },
      "QUERY": {
        "TYPE": "Belegart",
        "HEADER": "Suchen",
        "RESET": "Zurücksetzen",
        "SUBMIT": "Suchen",
        "SAVE_AND_QUERY": "Vorlage Speichern & Abfragen",
        "SAVE": "Vorlage Speichern"
      },
      "LIST": {
        "HEADER": "Suchergebnisse",
        "FILTER": "Abfrage:",
        "FIND_PLACEHOLDER": "Filtern",
        "NO_DATA": "Es konnten keine Daten gefunden werden",
        "RESULTS": "Belege",
        "COLUMNS": {
          "NUMBER": "Belegnummer"
        }
      },
      "BUSINESS_CASE": {
        "TITLE": "Geschäftsfall"
      }
    },
    "ACTIONS": {
      "ACTIONS": "Aktionen",
      "DOWNLOAD": "Herunterladen",
      "BUSINESS_CASE": "Geschäftsfall",
      "DOWNLOAD_BELEG": "Beleg",
      "DOWNLOAD_ARCHIVBELEG": "Archivbeleg",
      "DOWNLOAD_FREMDBELEG": "mit Fremdbeleg",
      "DOWNLOAD_DATENTRÄGERDATEI": "Datenträgerdatei",
      "EDIT-DELIVERY-NOTE": "Lieferschein bearbeiten"
    },
    "MODAL": {
      "CHOOSE": {
        "DOWNLOAD": {
          "TITLE": "Was möchten Sie herunterladen?"
        }
      },
      "ASK": {
        "COMBINE": {
          "TITLE": "Dateien zusammenführen",
          "TEXT": "Möchten Sie die markierten Belege in ein Dokument zusammenfassen?"
        }
      }
    },
    "MESSAGES": {
      "WARNING": {
        "LOAD_DEFINITIONS": "Das kundenspezifische Layout konnte nicht geladen werden."
      },
      "INFO": {
        "DOWNLOAD_CANCELLED": "Der Download wurde abgebrochen"
      }
    }
  }
}
